import { Head } from '@inertiajs/react'
import AppLayout from '@/layouts/AppLayout'
import PageHeader from '@/components/ui/PageHeader'
import { ArrowPathIcon } from '@heroicons/react/24/outline'

interface MigrationPendingProps {
  title: string
  legacyPath?: string
  subtitle?: string
}

// Generic placeholder shown for Inertia pages that haven't been ported from
// the legacy Webpacker/JSX stack yet. Keeps render-by-name resolution from
// crashing the front-end while the underlying controllers still work.
export default function MigrationPending({ title, legacyPath, subtitle }: MigrationPendingProps) {
  return (
    <>
      <Head title={title} />
      <PageHeader
        title={title}
        subtitle={subtitle || 'Page migration to the new stack is pending — using legacy view below.'}
        icon={<ArrowPathIcon className="h-5 w-5" />}
      />
      <div
        data-testid="migration-pending"
        className="rounded-lg border border-zinc-200 bg-white p-6 dark:border-zinc-700 dark:bg-zinc-900"
      >
        <p className="text-sm text-zinc-600 dark:text-zinc-400">
          The <span className="font-medium">{title}</span> screen is in the process of being rebuilt on the
          new React/Inertia/Tailwind stack. The original controller still works.
          {legacyPath && (
            <>
              {' '}Use the legacy URL: <code className="rounded bg-zinc-100 px-1.5 py-0.5 text-xs dark:bg-zinc-800">{legacyPath}</code>
            </>
          )}
        </p>
      </div>
    </>
  )
}

MigrationPending.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
